import type { StoreProductsParams } from '../api/use-store-products-query';

/** 정렬·페이지를 뺀 조건이 하나라도 걸려 있는지 — 초기화 버튼의 활성 조건. */
export const hasActiveStoreFilters = (filters: StoreProductsParams): boolean =>
  filters.categoryId !== undefined ||
  // 기획전도 목록을 좁히는 조건이다 — "필터 초기화"가 함께 푼다.
  filters.exhibitionId !== undefined ||
  filters.minOrderQtyMax !== undefined ||
  filters.unitPriceMin !== undefined ||
  filters.unitPriceMax !== undefined ||
  (filters.colorFamilies !== undefined && filters.colorFamilies.length > 0);
